import React, { useState, useEffect } from "react";
import {
  validateCPF,
  maskCPF,
  useCPFValidation,
} from "../../utils/cpfValidator";
import "./CPFInput.css";

const CPFInput = ({
  value = "",
  onChange,
  onValidationChange,
  placeholder = "Digite seu CPF",
  className = "",
  required = false,
  disabled = false,
  label = "CPF",
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);

  // Usa o hook de validação
  const validation = useCPFValidation(inputValue);

  // Notifica mudanças na validação para o componente pai
  useEffect(() => {
    if (onValidationChange) {
      onValidationChange(validation);
    }
  }, [validation]);

  // Atualiza o valor quando a prop value mudar
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e) => {
    const rawValue = e.target.value;
    const maskedValue = maskCPF(rawValue);

    setInputValue(maskedValue);

    if (onChange) {
      onChange(maskedValue, validation);
    }
  };

  const handleBlur = () => {
    setIsFocused(false);

    // Valida e formata quando perder o foco
    if (inputValue && inputValue.length > 0) {
      const validation = validateCPF(inputValue);
      if (validation.isValid) {
        setInputValue(validation.formatted);
        if (onChange) {
          onChange(validation.formatted, validation);
        }
      }
    }
  };

  const getInputClassName = () => {
    let classes = "cpf-input";

    if (className) {
      classes += ` ${className}`;
    }

    if (validation.isValid === false && inputValue.length > 0) {
      classes += " cpf-input--error";
    } else if (validation.isValid === true) {
      classes += " cpf-input--success";
    }

    if (isFocused) {
      classes += " cpf-input--focused";
    }

    return classes;
  };

  return (
    <div className="cpf-input-container">
      {label && (
        <label className="cpf-input-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}

      <input
        type="text"
        className={getInputClassName()}
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setIsFocused(true)}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={14} // XXX.XXX.XXX-XX
      />

      {/* Mensagem de erro */}
      {validation.error && inputValue.length > 0 && (
        <div className="cpf-input-error">{validation.error}</div>
      )}

      {/* Mensagem de sucesso */}
      {validation.isValid && inputValue.length > 0 && (
        <div className="cpf-input-success">CPF válido ✓</div>
      )}

      {/* Indicador de carregamento */}
      {inputValue.length > 0 && validation.isValid === null && (
        <div className="cpf-input-loading">Validando...</div>
      )}
    </div>
  );
};

export default CPFInput;
